'use strict';

import { CSSKeyframesRuleImpl } from '../platform';
export default function keyframes(keyframeDefinitions) {
  return new CSSKeyframesRuleImpl(keyframeDefinitions);
}
//# sourceMappingURL=keyframes.js.map